import { CohesionProvider } from '@redventures/cohesion-utils-react';
import { FC, ComponentType } from 'react';

type WithCohesionProps = {
    App: ComponentType<any>;
    assets: Record<string, ComponentType<{}>>;
};

export const withCohesion = ( { App, assets }: WithCohesionProps ): FC => {
  const CohesionProviderHOC: FC = ( props ) => (
        <CohesionProvider components={ assets }>
            <App { ...props } />
        </CohesionProvider>
  );
  CohesionProviderHOC.displayName = `withCohesion(${ App.displayName || App.name || 'Component' })`;
  return CohesionProviderHOC;
};
